import { UserRoleType } from "../../../types/admin/User";
import { isType } from "../../enumChecker";

export const canRoleOpenBulkEdit = (types: UserRoleType[]) => {
  return isUserRoletype(
    types,
    "ADMINISTRAATOR",
    "REGISTRI_HALDUR",
    "KVY_HALDUR",
    "REGISTRIPIDAJA",
    "KINNITAJA",
    "JK_KOORDINAATOR",
    "JK_KOOSTAJA",
  );
};

export const canRoleOpenStartProceeding = (types: UserRoleType[]) => {
  return isUserRoletype(types, "ADMINISTRAATOR", "REGISTRI_HALDUR", "REGISTRIPIDAJA", "KINNITAJA");
};

export const canRoleOpenOrgs = (types: UserRoleType[]) => {
  return isUserRoletype(types, "ADMINISTRAATOR", "REGISTRI_HALDUR");
};
export const canRoleOpenUsers = (types: UserRoleType[]) => {
  return isUserRoletype(types, "ADMINISTRAATOR", "REGISTRI_HALDUR", "KVY_HALDUR", "JK_KOORDINAATOR");
};
export const canRoleOpenAdminNotifications = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR");
};

export const canRoleOpenAdminThiAndVat = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR", "KVY_HALDUR");
};

export const canRoleOpenStartRealEstateUnit = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR", "KVY_HALDUR", "JK_KOORDINAATOR", "JK_KOOSTAJA");
};

export const canRoleOpenContractsWorkSpaces = (types: UserRoleType[]) => {
  return isUserRoletype(types, "ADMINISTRAATOR", "REGISTRI_HALDUR", "REGISTRIPIDAJA", "KINNITAJA");
};

const isUserRoletype = (types: UserRoleType[], ...matchTypes: Array<keyof typeof UserRoleType>) => {
  return types.reduce((sum, current) => sum || isType<typeof UserRoleType>(current, ...matchTypes), false);
};
